import React, { useEffect, useRef, useState } from "react";
import "./resultBody.scss";
import { connect } from "react-redux";
import StarsRating from "stars-rating";
import { useNavigate } from "react-router-dom";
import CollapsBlock from "../../../atoms/collapsBlock";
import { Modal } from "@mui/material";
import { Box } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import heartTick from "../../../assets/images/heart-tick.png";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import GradientSVG from "./gradientSVG";
import {
  getDeterminants,
  deleteUserResponse,
  updateSuggestion,
  updateReference,
  getSurveyList,
} from "../../../redux/action/user";
import CenterLoading from "../../core/CenterLoading";
import { isSubscriptionActive } from "../../../common";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  outline: "none",
};

const ResultBody = (props) => {
  const [open, setOpen] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [starValue, setStarValue] = useState(0);
  const navigate = useNavigate();
  const childRef = useRef();
  const isSubscription = isSubscriptionActive(props?.user);
  const Resume =
    (props.user.surveyIdList &&
      props.user.surveyIdList.length > 0 &&
      props.user.surveyIdList[props.user.surveyIdList.length - 1]
        .s_IsSurveyCompleted !== 1) ||
    false;

  useEffect(() => {
    props.getSurveyList().then((surveyLists) => {
      const assessmentKey = localStorage.getItem("assesmentKey");
      const currSurvey = surveyLists?.find((el) => el.SurveyId == assessmentKey);
      if (currSurvey?.s_IsSurveyCompleted === 1) {
        props.getDeterminants();
      }
    });
  }, []);

  useEffect(() => {
    if (props.user.determinantList && props.user.determinantList.length > 0) {
      setStarValue(
        props.user.userFinalScore >= 90
          ? 5
          : props.user.userFinalScore >= 78 && props.user.userFinalScore <= 89
            ? 4
            : props.user.userFinalScore >= 68 && props.user.userFinalScore <= 77
              ? 3
              : props.user.userFinalScore >= 50 && props.user.userFinalScore <= 67
                ? 2
                : 1
      );
    }
  }, [props.user.determinantList]);

  const onSubmitQuestion = (tempModalData) => {
    setModalData(tempModalData);
    if (props.user._id && tempModalData?.suggestionID) {
      props.updateSuggestion(props.user._id, tempModalData.suggestionID);
    }
    setOpen(!open);
  };

  const openDeleteModal = () => {
    setDeleteModal(true);
  };

  const deleteUserData = () => {
    if (props.user._id) {
      props.deleteUserResponse(props.user._id, props.user.surveyId, navigate);
      setDeleteModal(false);
    }
  };

  const startNewAssessment = () => {
    childRef.current?.startNewAssessment?.();
  };

  return (
    <div className="result-body">
      <CenterLoading
        open={props.user.isLoading}
        showSuggestions
        suggestionList={[
          props.user.language?.loading_suggestions?.sugg_0,
          props.user.language?.loading_suggestions?.sugg_1,
          props.user.language?.loading_suggestions?.sugg_2,
          props.user.language?.loading_suggestions?.sugg_3,
          props.user.language?.loading_suggestions?.sugg_4,
        ]}
      />

      <section className="assessment-hero">
        <div className="assessment-hero__inner">
          <div className="vitality-score-graphic">
            {!isSubscription ? (
              <p className="assessment-kicker assessment-kicker--mobile">
                Your vitality score
              </p>
            ) : null}
            <GradientSVG />
            <div className="chart-detail">
              <div className="chart-detail__chart">
                <CircularProgressbar
                  value={props.user.userFinalScore}
                  strokeWidth={8}
                  text={`${props.user.userFinalScore}`}
                  styles={buildStyles({
                    rotation: 1 / 2,
                    pathColor: `url(#hello)`,
                    trailColor: "#264448",
                    textColor: "#fff",
                  })}
                />
              </div>
            </div>
            <div className="score-result">
              <div style={{ display: "flex", justifyContent: "center" }}>
                <StarsRating
                  count={5}
                  value={starValue}
                  edit={false}
                  size={35}
                  color2={"#ffd700"}
                />
              </div>
            </div>
          </div>

          <div className="assessment-hero__copy">
            {!isSubscription ? (
              <p className="assessment-kicker assessment-kicker--desktop">
                Your vitality score
              </p>
            ) : null}
            <h1 className="assessment-hero__title">
              {isSubscription
                ? "Your Score & Personalized Japa Journey"
                : "Your Personalized Japa Journey"}
            </h1>
            <p className="assessment-hero__lede">
              {isSubscription
                ? "Your ten determinants are listed from lowest score to highest. Open a determinant, choose a suggestion, and set it as a goal to start raising your vitality."
                : "Your two lowest-scoring determinants are below, with suggestions to start on today. Become a member to unlock all ten, set goals, and track your progress."}
            </p>
            <div className="assessment-hero__actions">
              <button
                type="button"
                className="assessment-hero__cta"
                onClick={startNewAssessment}
              >
                {Resume ? "Resume" : "New Assessment"}
              </button>
              {isSubscription ? (
                <button
                  type="button"
                  className="assessment-hero__link"
                  onClick={() => navigate("/history")}
                >
                  View past results
                </button>
              ) : (
                <button
                  type="button"
                  className="assessment-hero__link"
                  onClick={() => navigate("/plans")}
                >
                  See membership
                </button>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="assessment-focus">
        {props.user.determinantList &&
          props.user.determinantList.length > 0 && (
            <CollapsBlock
              deleteVisible={props.user.emailaddress
                ?.toLowerCase()
                .endsWith("@japa.health")}
              modelOpen={onSubmitQuestion}
              data={props.user.determinantList}
              deleteUserData={openDeleteModal}
              ref={childRef}
            />
          )}
      </section>

      <Modal open={open} onClose={() => onSubmitQuestion({})}>
        <Box sx={style} className="goal-modal">
          <button
            type="button"
            className="goal-modal__close"
            aria-label="Close"
            onClick={() => onSubmitQuestion({})}
          >
            <CloseIcon fontSize="small" />
          </button>
          <div className="goal-modal__head">
            <img src={heartTick} alt="" />
            <div>
              {modalData.DeterminantName ? (
                <p className="goal-modal__kicker">{modalData.DeterminantName}</p>
              ) : null}
              <h2>{modalData.Suggestion}</h2>
            </div>
          </div>
          {modalData.Blurb ? (
            <p className="goal-modal__blurb">{modalData.Blurb}</p>
          ) : null}
          <div className="goal-modal__actions">
            {modalData.lmsUrl ? (
              <button
                type="button"
                className="goal-modal__cta"
                onClick={() => window.open(modalData.lmsUrl, "_blank")}
              >
                Proceed to goal
              </button>
            ) : null}
            <button
              type="button"
              className="goal-modal__ghost"
              onClick={() => {
                props.updateReference(props.user._id, modalData.suggestionID);

                let url = modalData.ReferenceLink;
                if (
                  url &&
                  !url.startsWith("http://") &&
                  !url.startsWith("https://")
                ) {
                  url = "https://" + url;
                }
                window.open(url, "_blank");
              }}
            >
              The science
            </button>
            {isSubscription &&
            modalData?.goalstatus?.icon === "in-progress-icon" ? (
              <button
                type="button"
                className="goal-modal__cancel"
                onClick={() => {
                  childRef &&
                    childRef.current.handleGoalsCancel(modalData, "remove");
                  setOpen(false);
                }}
              >
                Cancel goal
              </button>
            ) : null}
          </div>
        </Box>
      </Modal>

      <Modal
        open={deleteModal}
        onClose={() => setDeleteModal(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={deleteStyle} className="goal-modal goal-modal--compact">
          <h2>Clear and restart?</h2>
          <p className="goal-modal__blurb">
            This removes your current assessment answers so you can begin again.
          </p>
          <div className="goal-modal__actions">
            <button
              type="button"
              className="goal-modal__cta"
              onClick={() => deleteUserData()}
            >
              Clear
            </button>
            <button
              type="button"
              className="goal-modal__ghost"
              onClick={() => setDeleteModal(false)}
            >
              Cancel
            </button>
          </div>
        </Box>
      </Modal>
    </div>
  );
};

ResultBody.propTypes = {};
ResultBody.defaultProps = {};

const actionCreators = {
  getDeterminants,
  deleteUserResponse,
  updateSuggestion,
  updateReference,
  getSurveyList,
};

export default connect(
  ({ user }) => ({
    user,
  }),
  actionCreators
)(ResultBody);
